import { render, staticRenderFns } from "./MobileSpacer.vue?vue&type=template&id=29b4e4b3"
import script from "./MobileSpacer.vue?vue&type=script&lang=js"
export * from "./MobileSpacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports